/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { GlobalConstants } from '../constants/global-constants';
import { DeviceEquipmentDetailsReturnCodes } from '../models/device-equipment-details-return-codes';
import { AddFamilyInformationReturnCodes } from '../models/family-information-model';
import { LocalStorageService } from '@hcworkspace/sysque/toolbelt/utils';

export class FamilyInformationReceiveController {
  constructor(private localStorageService: LocalStorageService) {}

  public FamilyInformationSaveResult(response: AddFamilyInformationReturnCodes): void {
    this.localStorageService.updateDispatchLocalStorage('familyInformationSaveResponse', response);
  }

  public ApplyDataResult(response: DeviceEquipmentDetailsReturnCodes): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.DeviceEquipmentDetailsApplyDataResponse, JSON.stringify(response));
  }
}